/**
 * A simple message bus. Facilitates uncoupled communication between
 * components of fieldplay.
 */
import eventify from 'ngraph.events'

export default eventify({})
